import type { EventModel } from '@bryntum/scheduler-thin';
import type { DomConfig } from '@bryntum/core-thin';
import { formatTime24h } from '../../../../../utils/dateUtils';
import './eventRenderer.css';

interface ShiftEventRecord {
  startDate: string | Date;
  endDate: string | Date;
  name: string;
}

const timeRangeRow = (record: ShiftEventRecord): DomConfig => ({
  class: 'd-flex fw-semibold',
  children: [
    {
      class: 'text-truncate',
      text: `${formatTime24h(record.startDate)} – ${formatTime24h(
        record.endDate,
      )}`,
    },
  ],
});

const shiftNameRow = (name: string): DomConfig => ({
  class: 'text-truncate',
  style: 'font-size: 0.7rem',
  text: name,
});

const targetNameRow = (targetName: string): DomConfig => ({
  class: 'text-truncate opacity-75',
  style: 'font-size: 0.7rem',
  text: `@ ${targetName}`,
});

export const renderShiftEvent = (eventRecord: EventModel): DomConfig[] => {
  const rows: DomConfig[] = [timeRangeRow(eventRecord)];

  if (eventRecord.name) {
    rows.push(shiftNameRow(eventRecord.name));
  }

  const targetName = eventRecord.getData('targetName');

  if (targetName) {
    rows.push(targetNameRow(targetName));
  }

  return rows;
};
